import React from 'react';

import { Header } from './Header';
import { Footer } from './Footer';
import { useViewModel } from './useViewModel';
import { getPageComponent, getPageComponentProps } from './pageRegistry';

import styles from './modal.module.css';
import { usePage } from '../../context/PageContext';

/**
 * GiftWrapModal handles the product gift wrapping flow, including step navigation.
 * Uses dynamic page rendering based on the page registry.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.isOpen - Whether the modal is open.
 * @param {function} props.onClose - Callback for closing the modal.
 * @returns {import('react').JSX.Element}
 */
export function GiftWrapModal({ isOpen, onClose }) {
  const { dialogModalRef, handleClose } = useViewModel({ isOpen, onClose });
  const { currentPage } = usePage();

  // Get the component for the current page from the registry.
  const PageComponent = getPageComponent(currentPage);
  const pageProps = getPageComponentProps(currentPage);

  return (
    <dialog ref={dialogModalRef} className={styles['giftWrap__modal']}>
      <Header onClose={handleClose} />
      <div className={styles['giftWrap__modal-content']}>
        {PageComponent ? <PageComponent {...pageProps} /> : null}
      </div>
      <Footer />
    </dialog>
  );
}
